/* Cart Drawer JS */

(function() {
  'use strict';

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartBackdrop = document.querySelector('[data-cart-backdrop]');
  const cartCount = document.querySelector('[data-cart-count]');

  // Open cart drawer
  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  // Close cart drawer
  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  // Update cart count badge
  function updateCartCount(count) {
    if (cartCount) {
      cartCount.textContent = count;
      cartCount.dataset.cartCount = count;
    }
  }

  // Add to cart
  async function addToCart(formData) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) throw new Error('Add to cart failed');
      
      const data = await response.json();
      
      // Refresh cart drawer content
      await refreshCartDrawer();
      
      // Open cart
      openCart();
      
      return data;
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }

  // Update cart item quantity
  async function updateCartItem(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      
      if (!response.ok) throw new Error('Update cart failed');
      
      const data = await response.json();
      
      // Refresh cart drawer
      await refreshCartDrawer();
      
      return data;
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  // Remove item from cart
  async function removeCartItem(key) {
    return updateCartItem(key, 0);
  }

  // Refresh cart drawer content
  async function refreshCartDrawer() {
    try {
      const response = await fetch('/?section_id=cart-drawer');
      if (!response.ok) throw new Error('Failed to refresh cart');
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartContent = doc.querySelector('[data-cart-items]');
      const newCartFooter = doc.querySelector('.cart-drawer__footer');
      const newCartCount = doc.querySelector('[data-cart-count]');
      
      const currentCartItems = document.querySelector('[data-cart-items]');
      const currentCartFooter = document.querySelector('.cart-drawer__footer');
      
      if (newCartContent && currentCartItems) {
        currentCartItems.innerHTML = newCartContent.innerHTML;
      }
      
      if (newCartFooter && currentCartFooter) {
        currentCartFooter.innerHTML = newCartFooter.innerHTML;
      }
      
      if (newCartCount) {
        updateCartCount(newCartCount.textContent);
      }
      
      // Re-attach event listeners
      attachCartEventListeners();
      
    } catch (error) {
      console.error('Error refreshing cart:', error);
      // Fallback: reload page
      window.location.reload();
    }
  }

  // Attach event listeners to cart items
  function attachCartEventListeners() {
    // Quantity buttons in cart drawer
    document.querySelectorAll('[data-quantity-change]').forEach(button => {
      button.addEventListener('click', async (e) => {
        const key = button.dataset.quantityChange;
        const action = button.dataset.action;
        const item = button.closest('.cart-drawer__item');
        const quantityEl = item?.querySelector('.cart-drawer__quantity-value');
        const currentQty = parseInt(quantityEl?.textContent || '1');
        
        const newQty = action === 'plus' ? currentQty + 1 : currentQty - 1;
        
        if (newQty > 0) {
          await updateCartItem(key, newQty);
        } else {
          await removeCartItem(key);
        }
      });
    });

    // Remove buttons
    document.querySelectorAll('[data-remove-item]').forEach(button => {
      button.addEventListener('click', async (e) => {
        const key = button.dataset.removeItem;
        await removeCartItem(key);
      });
    });
  }

  // Event listeners
  if (cartToggle) {
    cartToggle.addEventListener('click', openCart);
  }

  if (cartClose) {
    cartClose.addEventListener('click', closeCart);
  }

  if (cartBackdrop) {
    cartBackdrop.addEventListener('click', closeCart);
  }

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawer?.classList.contains('is-open')) {
      closeCart();
    }
  });

  // Add to cart form handling
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const submitButton = form.querySelector('[data-add-to-cart]');
      const originalText = submitButton?.textContent;
      
      if (submitButton) {
        submitButton.textContent = 'AJOUTÉ AU PANIER';
        submitButton.disabled = true;
      }
      
      await addToCart(new FormData(form));
      
      setTimeout(() => {
        if (submitButton) {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }
      }, 2000);
    });
  });

  // Initial attachment of event listeners
  attachCartEventListeners();

})();